<template>
	<div class="home">
		<div class="banner_wrap">
			<div class="banner">
				<div class="left-text">
					<p class="title">全球领先汽车金融<br>解决方案提供商!</p>
					<p class="tips">千万家庭 必备选择</p>
				</div>
				<div class="register_box">
					<div class="title">
						<p>填写基本信息</p>
					</div>
					<div class="list">
						<div class="item">
							<input type="text" maxlength="10" @input="filterInput" placeholder="请输入您的贷款金额" v-model="money" />
							<span>万元</span>
						</div>
						<div class="item">
							<input type="text" maxlength="20" placeholder="请输入您的姓名" v-model="name" />
						</div>
						<div class="item">
							<input type="text" maxlength="30" placeholder="请输入您的车辆信息" v-model="carInfo" />
						</div>
						<div class="item">
							<input type="text" placeholder="请输入您的地址" v-model="address" />
						</div>
						<div class="item">
							<input type="text" maxlength="11" oninput="this.value=this.value.replace(/[^0-9.]/g,'');"
								placeholder="请输入您的11位手机号码" v-model="mobile" />
						</div>
						<div class="item">
							<input type="text" maxlength="11" oninput="this.value=this.value.replace(/[^0-9.]/g,'');"
								placeholder="请输入介绍人手机号" v-model="referrPhone" />
						</div>
						<div class="item_code">
							<div class="get_btn" @click="show()">立即申请</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="tag-list">
			<div class="item">
				<img src="../assets/img/icon-1.png" alt="" class="icon icon01">
				<p class="tag-name">海量产品车源</p>
				<p class="tips">40000+分期产品</p>
				<p class="tips">百万新车+二手车车源</p>
			</div>
			<div class="item">
				<img src="../assets/img/icon-2.png" alt="" class="icon icon02">
				<p class="tag-name">在线审批放款快</p>
				<p class="tips">最快 10秒钟 通过在线审批</p>
				<p class="tips">最快申请当日即可放款</p>
			</div>
			<div class="item">
				<img src="../assets/img/icon-3.png" alt="" class="icon icon03">
				<p class="tag-name">免费咨询</p>
				<p class="tips">高质量服务</p>
				<p class="tips">为您提供高效专业分期咨询服务</p>
			</div>
			<div class="item">
				<img src="../assets/img/icon-4.png" alt="" class="icon icon04">
				<p class="tag-name">省钱省事</p>
				<p class="tips">低首付低利率 购车无压力</p>
				<p class="tips">万元首付 新车开走吧</p>
			</div>
			<div class="item">
				<img src="../assets/img/icon-5.png" alt="" class="icon icon05">
				<p class="tag-name">私人定制</p>
				<p class="tips">220+品牌金融机构</p>
				<p class="tips">为您订制优质金融方案</p>
			</div>
		</div>

		<div class="pop" v-if="flag">
			<p>已收到您的申请信息，稍后会安排客服经理与您对接，请稍作等待！</p>
			<div class="sure_btn">
				<span @click="Cancel()">确定</span>
			</div>
			<i class="icon_clear" @click="Cancel()"></i>
		</div>

	</div>
</template>

<script>
import $http from '../api'
export default {
	data() {
		return {
			money: '',
			name: '',
			carInfo: '',
			address: '',
			mobile: '',
			referrPhone:'',
			flag: false,
		}
	},
	methods: {
		filterInput(event) {
			// 使用正则表达式只允许数字和小数点
			event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
		},
		show() {
			if (this.money && this.name && this.carInfo && this.address) {
				let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				if (!reg.test(this.mobile) || (this.referrPhone && !reg.test(this.referrPhone))) {
					alert('请填写正确的手机号！')
				} else {
					$http.post('/customer/save', {
						loanMoney: this.money,
						customerName: this.name,
						carInfo: this.carInfo,
						address: this.address,
						phone: this.mobile,
						channel: 2
					}).then(res => {
						if (res.code === 0) {
							this.flag = true;
						} else {
							alert(res.msg || "网络异常，请稍后再试")
						}
					}).catch(err => { 
						alert("网络异常，请稍后再试")
					})
				}
			} else {
				alert('请填写完整信息！')
			}
		},
		Cancel() {
			this.money = '';
			this.name = '';
			this.carInfo = '';
			this.address = '';
			this.mobile = '';
			this.code = '';
			this.referrPhone = '';
			this.flag = false;
		},
	},
	mounted() {
	}
}
</script>
<style lang="scss" scoped>

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

.home {
	background: #fff;
	width: 100%;
	padding-bottom: 40px;

	.pop {
		display: block;
		width: 340px;
		height: 95px;
		padding: 50px 50px 30px;
		border-radius: 10px;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		z-index: 8;
		background: #fff;
		box-shadow: 0px 0px 40px #333;

		p {
			line-height: 25px;
			font-size:14px;
		}

		i.icon_clear {
			display: block;
			width: 25px;
			height: 25px;
			background: url(../assets/img/clear.png) no-repeat;
			background-size: 100%;
			position: absolute;
			right: 8px;
			top: 8px;
			z-index: 9;
			cursor: pointer;
		}

		.sure_btn {
			height: 35px;
			text-align: right;
			margin-top:15px;
			span {
				display: inline-block;
				width: 100px;
				height: 35px;
				line-height: 35px;
				text-align: center;
				background: #1262B2;
				color: #fff;
				font-size: 16px;
				cursor: pointer;
				border-radius: 4px;
			}
		}
	}

	.compony {
		line-height: 45px;
		text-align: center;
		font-size: 22px;
		color: #000000;
		opacity: 0.3;

		.copy {
			height: 30px;
			line-height: 30px;

			a {
				color: #000000;
				font-size: 16px;
			}
		}
	}

	.img_wrap {
		padding: 65px 0;
		background: #fff;

		img {
			display: block;
			width: 1200px;
			margin: 0 auto;
		}
	}

	.banner_wrap {
		width: 100%;
		height: 640px;
		background: url(../assets/img/banner1.png) no-repeat;
		background-size: 100% 100%;

		.banner {
			width: 1200px;
			margin: 0 auto;
			overflow: hidden;
			display: flex;
			justify-content: space-between;
			padding-top: 77px;

			.left-text {
				padding-top: 85px;

				.title {
					font-size: 72px;
					color: #fff;
					line-height: 96px;
					letter-spacing: 2px;
				}

				.tips {
					font-size: 36px;
					color: #ffffff;
					margin-top: 35px;
				}
			}

			.register_box {
				width: 424px;
				height: 500px;
				background-color: #ffffff;
				border-radius: 12px;
				padding: 35px 24px 29px;
				box-sizing: border-box;

				.title {
					p {
						color: #333333;
						font-size: 24px;
						line-height: 24px;
						font-weight: bold;
					}
				}

				.list {
					margin-top: 20px;

					.item {
						height: 45px;
						background-color: #f9f9f9;
						border-radius: 4px;
						margin-bottom: 10px;
						padding: 0 15px 0 12px;
						position: relative;
						box-sizing: border-box;
						display: flex;
						align-items: center;

						input {
							display: block;
							flex: 1;
							width: 100%;
							height: 100%;
							line-height: 100%;
							border: none;
							font-size: 16px;
							background: transparent;
						}

						span {
							display: block;
							font-size: 14px;
							color: #757575;
						}
					}

					.item_code {
						margin-top: 24px;

						.get_btn {
							height: 54px;
							line-height: 54px;
							text-align: center;
							background-color: #0f5eb7;
							border-radius: 8px;
							font-size: 20px;
							color: #ffffff;
							cursor: pointer;
						}
					}
				}
			}
		}
	}

	.tag-list{
		width:1200px;
		margin:96px auto 0;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		gap: 24px;
		.item{
			width: 384px;
			height: 270px;
			background-color: #f4f5f6;
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: center;
			.icon{
				display: block;
				width:55px;
				height: 42px;
				&.icon02{
					width:44px;
					height: 52px;
				}
				&.icon03{
					width:50px;
					height: 50px;
				}
				&.icon04{
					width:54px;
					height: 50px;
				}
				&.icon05{
					width:46px;
					height: 44px;
				}
			}
			.tag-name{
				color: #0f5eb7;
				font-size:22px;
				margin:19px 0 5px;
			}
			.tips{
				font-size: 14px;
				line-height:20px;
				color: rgba(40,40,40,.6)
			}
		}
	}
}
</style>